<template>
<b-container class="register-organization-container">
        <div class="login-form-wrapper">
<branding-heading></branding-heading>
<b-row v-show="loading">
	<b-col class="pb-3">
		<b-spinner v-show="loading" label="Checking Your rejection Code..."></b-spinner> Checking server... please wait...
	</b-col>
</b-row>
<b-row v-show="status == null">
	<b-col >
	<h1>Reject New User Account</h1>
	<b-form-group label="Rejection Message" label-for="edit-lcr__traffic-effect" :state="reason.status" :invalid-feedback="reason.invalidMessage">
		<p>Please enter a message that will be included the email sent to the person requesting the new account.</p>
		<b-form-textarea id="edit-lcr__traffic-effect" rows="4" no-resize v-model="reason.value" @input="reason.resetStatus()" :state="reason.status">
		</b-form-textarea>
	</b-form-group>

	<div class="pr-3 mb-2">
		<b-button variant="primary" @click="onSubmit">Reject New Account <b-spinner small label="Saving..." class="ml-2" v-if="saving"></b-spinner>
		</b-button>
		<b-button variant="light" @click="goBack" class="ml-3">Back to Login</b-button>
	</div>

	</b-col>
</b-row>
<b-row v-show="status == 'success'">
	<b-col >
	<h2>New user account is now rejected.</h2>
	<p><router-link to="/" class="btn btn-primary">Back to Lane Closures</router-link></p>
	</b-col>
</b-row>
<b-row v-show="status == 'error'">
	<b-col v-if="errorCode == 'error.rejectAppUserRequest.alreadyApproved'">
	<h2>Error: Account was already approved.</h2>
	<p>If you need to disable this account, please log into the Lane Closures system.</p>
	<p><router-link to="/" class="btn btn-primary">Back to Lane Closures</router-link></p>
	</b-col>
	<b-col v-else>
	<h2>There was an issue rejecting the account.</h2>
	<p>{{errorMessage}}</p>
	<p><router-link to="/" class="btn btn-primary">Back to Lane Closures</router-link></p>
	</b-col>

</b-row>

<b-modal centered v-model="showRequiredFieldModal" type="info" @confirm="showRequiredFieldModal = false">
	<template v-slot:modal-title>{{$t('errors.errorsOccurred')}}</template>
	<ul>
		<li v-for="requiredField in modalRequiredFieldList" v-bind:key="'reqfield'+requiredField">{{$t(requiredField)}}</li>
	</ul>
	<template slot="footer">
		<b-button :disabled="isButtonDisabled" colour="light" :value="$t('labels.ok')" @click="modalRequiredFieldClose" />
	</template>
</b-modal>
<!-- leaving page -->
<b-modal centered id="unsaved-changes-error-modal" title="Unsaved Changes" size="lg" v-model="showUnsavedChangesModal" @ok="modalOnCancel()">
	<p class="is-size-6">{{ $t('messages.unsavedChanges') }}</p>
	<template v-slot:modal-footer="{ ok }">
		<!-- <b-button variant="primary"  type="button" @click="modalOnSave">{{$t('labels.save')}} <b-spinner small label="Saving..." class="ml-2" v-if="saving"></b-spinner></b-button> -->
		<b-button variant="danger" type="button" @click="modalOnLeave">{{$t('labels.leaveAnyway')}}</b-button>
		<b-button variant="secondary"  type="button" @click="modalOnCancel">{{$t('labels.stay')}}</b-button>
	</template>
</b-modal>
</div>
</b-container>
</template>


<script>
import BootstrapField from '../../../utility/BootstrapField';
import ErrorHandler from '../../../utility/ErrorHandler';
import Format from '../../../utility/Format';
import Vue from 'vue'
import BrandingHeading from '../../../components/BrandingHeading';
export default {
  name: 'RejectUserRegistration',
  docTitle: "Reject New User Account - Lane Closures",

  components: {
  	BrandingHeading
  },
  props:['jwt'],
  data() {
	return {
		form: null,
		showUnsavedChangesModal:false,
		lineIndexError:null,
		isButtonDisabled: false,
		saveState:null,
		modalRequiredFieldList: [],
		showRequiredFieldModal: false,
		errorCode:null,
		errorMessage:null,
		show: true,
		status:null,
		loading:false,
		submitted: false,
		resendToken:null,
		onSubmitPromiseDeferred: {
			resolve:null,
			reject:null
		},
		usernamePrefix:new BootstrapField({
					value: null}),
		reason:new BootstrapField({
					value: "Your user account was rejected.",
					required:true}),
	}
	},
	mounted() {
   },
	computed: {
	},
	watch: {
	},
  methods: {
  	goBack() {
  		this.$router.push('/')
  	},
  	modalOnCancel() {
  		this.showUnsavedChangesModal = false;
  	},
  	onSubmit:function() {
  		this.sendConfirmToken();
	  	this.$nextTick(() => {
	  	})
  	},


	// required fields notifying modal
	modalRequiredFieldClose(){
		this.showRequiredFieldModal = false;
	},
	getFlatTree(option) {
		if (option.namePath) {
			return Format.pipesToFlatTree(option.namePath);
		} else {
			return option.name;
		}
	},
	showErrors(errors){
		this.submissionStatus = 'submission-error';
		this.modalRequiredFieldList = [];
		for(let field in errors) {
			this.modalRequiredFieldList.push(errors[field]);
		}
		this.showRequiredFieldModal = true;
	},

		sendConfirmToken() {
			if (this.jwt != null) {
				this.errorMessage = null;
				this.errorCode = null;
				this.loading = true;
				Vue.prototype.$http({
					method: 'post',
					url: `${this.$store.state.apiUrl}/reject-user-registration/?r=${Math.round(Math.random() * Math.pow(10, 6))}`,
					data: { jwt:this.jwt, approvalReason:this.reason.value}
				}).then(response => {
					// Handle Success
					this.loading  = false;
					this.status = "success";
				}).catch(error => {
					this.loading = false;
					this.saveState = 'fail';
					this.status = "error";
					this.errorMessage = error.response.data.error.message;
					this.errorCode = error.response.data.error.code;
					if (!ErrorHandler.HasLoginErrorCode(error)) {
						// this.form.SetErrors(error.response.data);
						// this.showErrors(error.response.data.fields);
					} else {
						// ErrorHandler.RedirectToLogin();
					}
					this.onSubmitPromiseDeferred.reject();
				}).finally(() => {
					this.isButtonDisabled = false;
				});
			}
		},

	},
	beforeRouteLeave(to, from, next) {
		if (this.loaded && this.form.hasChanges()) {
			if (this.overrideUnsavedChanges) {
				next(true);
			} else {
				this.showUnsavedChangesModal = true;
				this.modalOnSave = (function() {
					this.onSubmit().then(() => {
						next(true);
					}).catch(() => {
						next(false);
					});
				}).bind(this);

				this.modalOnLeave = (function() {
					this.showUnsavedChangesModal = false;
					next(true);
				}).bind(this);

				next(false);
			}
		}
		else {
			next(true);
		}
	},

}
</script>
<i18n>
{
	"en-CA": {

	}
}

</i18n>